
import Vue from 'vue'
import { getClosest, set, unset } from 'utils/general'

export default el => Promise.all([
  enqueueModule('form-klaviyo.vue')
]).then(() => new Vue({
  el
}))
